<template>
  <el-container class="bigMain">
    <el-header :class="{ 'el-header-mobile': isMobile }">
      <The-header></The-header>
    </el-header>
    <el-main :class="{ 'el-main-unmobile': !isMobile }">
      <!-- <The-swiper></The-swiper> -->
      <The-image v-show="src.path !== '/home-page'" :src="src"></The-image>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
      <The-footer v-if="src.path !== '/home-page'"></The-footer>
    </el-main>

    <!-- <div class="cc-loader-container" v-show="pendingLength > 0">
      <div class="cc-loader-container-content"></div>
      <Loader></Loader>
    </div> -->
  </el-container>
</template>
<script>
  // import Loader from '@/components/loader';
  export default {
    // 文件主入口
    name: 'main-index',
    // components: { Loader},
    data() {
      return {
        swiperList: [
          {
            name: 'swiper-home.jpg',
            position: 'index',
            path: '/home-page',
            icon: '',
            link: '',
            bannerImgVideo: 1,
            key: 'home-page',
            title: '放心选择 全面守护',
            tips: '全方位保障您的数据安全与个人隐私',
            content:
              '作为科技驱动的新居住服务商，贝壳致力于推进居住服务产业数字化和智能化进程。贝壳高度重视数据安全合规，持续的研发投入与科技创新为居住产业数据安全与用户隐私保驾护航，为三亿中国家庭提供安全、高质、高效的居住服务，以打造“对消费者好、帮助服务者对消费者好”的新居住平台。'
          },
          {
            name: 'swiper-home.jpg',
            position: 'index',
            path: '/home-page-tile',
            icon: '',
            link: '',
            bannerImgVideo: 1,
            key: 'home-page-tile',
            title: '放心选择 全面守护',
            tips: '全方位保障您的数据安全与个人隐私',
            content:
              '作为科技驱动的新居住服务商，贝壳致力于推进居住服务产业数字化和智能化进程。贝壳高度重视数据安全合规，持续的研发投入与科技创新为居住产业数据安全与用户隐私保驾护航，为三亿中国家庭提供安全、高质、高效的居住服务，以打造“对消费者好、帮助服务者对消费者好”的新居住平台。'
          },
          {
            name: 'swiper-manage.jpg',
            position: 'privacyAdmin',
            path: '/privacy-manage',
            icon: '',
            link: '',
            bannerImgVideo: 1,
            key: 'privacy-manage',
            title: '您的信息 由您做主',
            tips: '以用户权益为中心，以创新科技为驱动',
            content:
              '贝壳平台提供多重安全保障，用创新科技为您提供全方位的隐私保护。您的每一次浏览、每一次交易都被严格加密。在个人隐私最为珍贵的时代，我们为您守护这份珍贵。'
          },
          {
            name: 'swiper-protect.jpg',
            position: 'privacyProtected',
            path: '/privacy-protect',
            icon: '',
            link: '',
            bannerImgVideo: 1,
            key: 'privacy-protect',
            title: '科技护航 合法有度',
            tips: '尊重并保护您的隐私安全',
            content:
              '个人隐私是一项基本的用户权利，随着全球产业数字化转型以及居住行业的不断发展，数据安全和个人信息隐私保护比以往任何时候都更为重要。我们坚持科技护航隐私，通过技术创新、研发投入和功能升级，为您营造更安全的消费环境。'
          },
          {
            name: 'swiper-policy.jpg',
            position: 'privacyPolicy',
            path: '/privacy-policy',
            icon: '',
            link: '',
            bannerImgVideo: 1,
            key: 'privacy-policy',
            title: '贝壳集团隐私声明',
            tips: '',
            content:
              '为了便于您了解我们如何收集、使用、传输、存储、提供、保护您的个人信息及您的权利如何行使，我们特此制定《贝壳集团隐私声明》。除《贝壳集团隐私声明》外，贝壳旗下产品（如贝壳找房App）均发布了专门的隐私声明，建议您在使用时仔细阅读，以帮助您更好地了解我们的产品或服务并作出适当的选择。'
          },
          {
            name: 'swiper-attest.jpg',
            position: 'userCenter',
            path: '/privacy-attestation',
            icon: '',
            link: '',
            bannerImgVideo: 1,
            key: 'privacy-attestation',
            title: '以用户为中心',
            tips: '',
            content: ''
          }
        ],
        src: ''
      };
    },
    async created() {
      this.readDictByKey('banner', (res) => {
        let obj = res.list.map;
        this.swiperList.forEach((item) => {
          item.bannerImgVideo =
            obj[item.position].bannerImgVideo === null ? 2 : obj[item.position].bannerImgVideo;
          item.icon =
            item.bannerImgVideo == 1
              ? obj[item.position].pic
                ? obj[item.position].pic
                : require(`@/assets/images/${item.name}`)
              : obj[item.position].videoUrl
              ? obj[item.position].videoUrl
              : 'https://devlawtrust-1306822285.cos.ap-beijing.myqcloud.com/banner/waterfall0525fps.mp4';
          item.link = obj[item.position].link;
        });
      });
    },
    computed: {
      pendingLength() {
        return this.$store.state.loading.pendingLength;
      }
    },
    watch: {
      '$route.path': {
        handler(val) {
          let index = this.swiperList.findIndex((item) => item.path === val);
          this.src = this.swiperList[index];
        },
        immediate: true
      }
    },
    methods: {}
  };
</script>
<style lang="scss" scoped>
  .bigMain {
    overflow: hidden;
    width: 100%;
    height: 100%;

    .el-header-mobile {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 2001;
    }

    .el-main-unmobile {
      overflow: auto;
      min-width: calc($multiple * 1040px);
    }
  }
</style>
